import Webhooks from 'shared/webhooks';
import useWebhooksHostProps from './useWebhooksHostProps';

export default function WebhooksPage() {
  const hostProps = useWebhooksHostProps();

  return <Webhooks {...hostProps} />;
}
